import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from './components/ui/Toaster';
import { router } from './router';
import { useAuth } from './store/auth';
import { useTheme } from './store/theme';
import { useI18n } from './i18n';

export function App() {
  const initAuth = useAuth((s) => s.init);
  const initTheme = useTheme((s) => s.init);
  const initI18n = useI18n((s) => s.init);

  useEffect(() => initTheme(), [initTheme]);
  // Resolves the locale and stamps <html lang> before the first render lands.
  useEffect(() => initI18n(), [initI18n]);
  useEffect(() => initAuth(), [initAuth]);

  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
}
